import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

/**
 * for this page
 */

class imgWrapperTab extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
    };

    render() {
        // console.log('imgWrapperTab=', this.props);
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        return (
            <div className={styles.imgWrapperTab}>
                <a href={content[0].url} className={styles.tab}>
                    {content[0].title}
                </a>
            </div>
        );
    }
}

export default errorBoundary(imgWrapperTab);
